function CustomInput({
  type = 'text',
  id,
  placeholder = '',
  register,
  option,
  label,
  error,
  className,
  width = 'w-full',
  as,
}) {
  if (as === 'textarea') {
    return (
      <div className={`relative ${className}`}>
        <textarea
          rows="5"
          type={type}
          id={id}
          placeholder={placeholder}
          className={`bg-white peer ${width} mt-1 block  px-3 pt-5 pb-2 border rounded-md shadow-sm text-gray-900  
            focus:outline-none focus:ring-2 focus:ring-black focus:bg-[#FFFEF8]
            `}
          {...option}
        ></textarea>
        {error && <p className="mt-1 text-sm text-red-500">{error.message}</p>}
        {/* {formErrors?.email?.[0] && (
        <p className="text-red-500 text-sm">{formErrors.email[0]}</p>
      )} */}
      </div>
    );
  }
  return (
    <div className={`relative ${className}`}>
      <input
        type={type}
        id={id}
        placeholder={placeholder}
        className={`bg-white peer ${width} mt-1 block  px-3 pt-5 pb-2 border rounded-md shadow-sm text-gray-900  
            focus:outline-none focus:ring-2 focus:ring-black focus:bg-[#FFFEF8]
            `}
        {...option}
      />
      <label
        htmlFor="email"
        className="absolute left-3 top-[2px] text-black text-sm transition-all duration-200 ease-in-out 
              peer-placeholder-shown:top-3 peer-placeholder-shown:text-[#CDCBCC;] 
              peer-placeholder-shown:text-base peer-focus:top-1 peer-focus:text-xs 
              peer-focus:text-[#222224] peer-focus:pt-1 px-1"
      >
        {label}
      </label>
      {error && <p className="mt-1 text-sm text-red-500">{error.message}</p>}
      {/* {formErrors?.email?.[0] && (
        <p className="text-red-500 text-sm">{formErrors.email[0]}</p>
      )} */}
    </div>
  );
}

export default CustomInput;
